import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FaChevronUp } from 'react-icons/fa';

const ScrollButton = styled.button`
    position: fixed;
    bottom: 30px;
    right: 30px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: linear-gradient(135deg, #C65DC6 0%, #E180F7 50%, #7F58B7 100%);
    border: 1px solid rgba(225, 128, 247, 0.5);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 1000;
    opacity: ${props => props.$visible ? 1 : 0};
    visibility: ${props => props.$visible ? 'visible' : 'hidden'};
    transition: opacity 0.3s ease, visibility 0.3s ease, transform 0.3s ease;
    transform: ${props => props.$visible ? 'translateY(0)' : 'translateY(20px)'};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);
    }

    &:active {
        transform: translateY(-2px);
    }

    svg {
        width: 24px;
        height: 24px;
    }
`;

export default function ScrollToTop() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY;
            setIsVisible(scrollPosition > 100); // Show after scrolling 100px
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        // Clear the hash from URL
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
    };

    return (
        <ScrollButton 
            $visible={isVisible} 
            onClick={scrollToTop}
            aria-label="Scroll to top"
        >
            <FaChevronUp />
        </ScrollButton>
    );
}

